"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _container = _interopRequireDefault(require("../container"));
var _icon = _interopRequireDefault(require("../icon"));
var _indexModule = _interopRequireDefault(require("./index.module.scss"));
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
const ESCAPE_KEYCODE = 27;
const TAB_KEYCODE = 9;
const FOCUSABLE_ELEMENTS = 'a[href], button, textarea, input, select';
const Modal = _ref => {
  let {
    className,
    classNames,
    onDismissButtonClick: onDismiss,
    children,
    containerSize = 'medium',
    internalDismiss,
    isOpen,
    shouldCloseOnOverlayClick,
    a11y,
    dialogId
  } = _ref;
  const overlayRef = (0, _react.useRef)(null);
  const modalRef = (0, _react.useRef)(null);
  const dismissRef = (0, _react.useRef)(null);
  const handleTabKey = e => {
    if (!modalRef.current || !dismissRef.current) {
      return;
    }
    const focusables = modalRef.current.querySelectorAll(FOCUSABLE_ELEMENTS);
    const lastFocusable = focusables[focusables.length - 1];
    if (!e.shiftKey && document.activeElement === lastFocusable) {
      dismissRef.current.focus();
      e.preventDefault();
    } else if (e.shiftKey && document.activeElement === dismissRef.current) {
      lastFocusable.focus();
      e.preventDefault();
    }
  };
  const handleKeyDown = (0, _react.useCallback)(e => {
    if (e.keyCode === ESCAPE_KEYCODE) {
      // Escape cancels the modal.
      onDismiss();
    }
    if (e.keyCode === TAB_KEYCODE) {
      // Trap  focus in the modal
      handleTabKey(e);
    }
  }, [onDismiss]);
  const handleOverlayClick = (0, _react.useCallback)(e => {
    if (shouldCloseOnOverlayClick && e.target === overlayRef.current) {
      // Overlay click cancels the modal.
      onDismiss();
    }
  }, [onDismiss, shouldCloseOnOverlayClick]);
  (0, _react.useEffect)(() => {
    if (isOpen && modalRef.current && dismissRef.current) {
      const focusables = modalRef.current.querySelectorAll(FOCUSABLE_ELEMENTS);
      // Note: focuseables[0] === dismissRef
      const firstFocusable = focusables[1];
      if (firstFocusable) {
        firstFocusable.focus();
      } else {
        dismissRef.current.focus();
      }
    }
    document.body.style.overflow = isOpen ? 'hidden' : 'unset';
  }, [isOpen]);
  (0, _react.useEffect)(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [handleKeyDown]);
  (0, _react.useEffect)(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_indexModule.default.Modal, {
      [_indexModule.default.modalOpen]: isOpen
    }, className, classNames === null || classNames === void 0 ? void 0 : classNames.overlay),
    ref: overlayRef,
    onClick: handleOverlayClick
  }, /*#__PURE__*/_react.default.createElement(_container.default, {
    type: containerSize,
    className: (0, _classnames.default)(_indexModule.default.modalContents, classNames === null || classNames === void 0 ? void 0 : classNames.content)
  }, /*#__PURE__*/_react.default.createElement("div", {
    "aria-modal": true,
    role: "dialog",
    "aria-label": a11y === null || a11y === void 0 ? void 0 : a11y.label,
    "aria-labelledby": a11y === null || a11y === void 0 ? void 0 : a11y.labelledby,
    "aria-describedby": a11y === null || a11y === void 0 ? void 0 : a11y.describedby,
    ref: modalRef,
    id: dialogId
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: (0, _classnames.default)(internalDismiss ? _indexModule.default.internalDismiss : _indexModule.default.externalDismiss, classNames === null || classNames === void 0 ? void 0 : classNames.icon),
    type: "button",
    "aria-label": "Dismiss modal",
    ref: dismissRef,
    onClick: onDismiss
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    type: "cross",
    className: _indexModule.default.icon,
    size: "small"
  })), children)));
};
var _default = exports.default = Modal;